import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TestRunDocumentFile } from '../models/test-run-document-file';

@Component({
  selector: 'app-test-tool-file-info',
  templateUrl: './test-tool-file-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./test-tool-file-info.component.scss']
})
export class TestToolFileInfoComponent {
  @Input() title = '';
  @Input() file = new TestRunDocumentFile();
  @Input() compareTo: TestRunDocumentFile = null;
  @Input() color = 'yellow';
  @Input() differencesAccepted = false;

  hiliteContentType(): boolean {
    return this.file && this.compareTo && this.file.ContentType !== this.compareTo.ContentType;
  }

  hiliteEncoding(): boolean {
    return this.file && this.compareTo && this.file.Encoding !== this.compareTo.Encoding;
  }

  hiliteBomPresent(): boolean {
    return this.file && this.compareTo && this.file.BomPresent !== this.compareTo.BomPresent;
  }

  hiliteContentLength(): boolean {
    return this.file && this.compareTo && (this.file.Content?.length ?? 0) !== (this.compareTo.Content?.length ?? 0);
  }
}
